import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { getPostById } from '../../../redux/postsReducer';
import Header from '../../views/Header/Header';
import Canonical from "../../features/Canonical"
import styles from './SinglePost.module.scss';
import ReactMarkdown from 'react-markdown';

const SinglePost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const productData = useSelector(state => getPostById(state, id));
  const posts = useSelector(state => state.posts); // Получаем все посты
  const startRef = useRef(null);

  // Найти индекс текущего поста
  const currentIndex = posts.findIndex(post => post.id === id);
  const prevPost = posts[currentIndex - 1];
  const nextPost = posts[currentIndex + 1];

  const handleScroll = (ref) => {
    window.scrollTo({
      top: ref.offsetTop,
      left: 0,
    });
  };

  useEffect(() => {
    handleScroll(startRef.current);
  }, []);

  // Переключение к следующему посту
  const handleNext = () => {
    if (nextPost) {
      navigate(`/Blog/${nextPost.id}`);
    }
  };

  const handlePrev = () => {
    if (prevPost) {
      navigate(`/Blog/${prevPost.id}`);
    }
  };

  return (
    <>
      <Header />
      <div className={styles.SinglePost} ref={startRef}>
        <h1 className={styles.SinglePostTitle}>{productData.title}</h1>
        {/* <img style={{width: '300px'}} src={productData.image} alt={`imageForPost${productData.id}`}></img> */}
        <div className={styles.SinglePostContent}>
          <ReactMarkdown>
            {productData.content}
          </ReactMarkdown>
        </div>
        <div className={styles.SinglePostNavigation}>
          <button onClick={handlePrev} disabled={!prevPost}>Предыдущий</button>
          <button onClick={() => window.location.href = '/#blog'}>Все посты</button>
          <button onClick={handleNext} disabled={!nextPost}>Следующий</button>
        </div>
      </div>
    </>
  )
}

export default SinglePost